export const sizes = [48]

export const sortOptions = [
    {
        id: "score",
        value: {
            name: "Featured",
            sort: [
                {
                    field: "score",
                    order: "desc",
                },
            ],
        },
    },
    {
        id: "-price",
        value: {
            name: "Price descending",
            sort: [
                {
                    field: "price",
                    order: "desc",
                },
            ],
        },
    },
    {
        id: "price",
        value: {
            name: "Price ascending",
            sort: [
                {
                    field: "price",
                    order: "asc",
                },
            ],
        },
    },
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 5,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    currency: "EUR",
}
